export default function dispatch(vm, componentName, eventName, ...rest) {
  let parent = vm.$parent || vm.$root
  let name = parent.$options.name

  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent
    if (parent) {
      name = parent.$options.name
    }
  }

  if (parent) {
    parent.$emit.apply(parent, [eventName].concat(rest))
  }
}
